module.exports = __webpack_public_path__ + "static/media/logo-header-old.5643c100.svg";